import { createContext } from 'react'
import type { EncryptionKey, KeyRing, StorageMode } from '@/infra/crypto/key-ring'
import type { EncryptedPayload } from '@/infra/crypto/payloads'

export type KeyRingStatus = 'missing' | 'loaded'

export interface CryptoContextValue {
  readonly keyRingStatus: KeyRingStatus
  readonly cryptoInitialized: boolean
  readonly storageMode: StorageMode
  readonly isReady: boolean
  readonly activeKeyVersion: number | null
  readonly keys: readonly EncryptionKey[]
  readonly loadKeyRing: (keyRing: KeyRing) => void
  readonly clearKeys: () => void
  readonly rotateKey: () => Promise<KeyRing>
  readonly setStorageMode: (mode: StorageMode) => void
  readonly exportKeyRing: () => void
  readonly importKeyRing: (file: File) => Promise<void>
  readonly encrypt: (data: string | Record<string, unknown>) => Promise<EncryptedPayload>
  readonly decrypt: (payload: EncryptedPayload) => Promise<unknown>
}

export const CryptoContext = createContext<CryptoContextValue | undefined>(undefined)
